import { faker } from '@faker-js/faker/locale/cs_CZ';
import { PREFIX_PHONE } from '../../../constants';

export const generateFirstName = () => {
  return faker.person.firstName();
};

export const generateLastName = () => {
  return faker.person.lastName();
};

export const generateBirthNumber = (genderArg?: 'male' | 'female') => {
  const marker = genderArg === 'female' ? 50 : 0;

  const birthday = faker.date.birthdate({ min: 18, max: 60, mode: 'age' });

  const yy = birthday.getFullYear().toString().slice(-2);
  const mm = String(birthday.getMonth() + 1 + marker).padStart(2, '0');
  const dd = String(birthday.getDate()).padStart(2, '0');

  const sss = faker.string.numeric(3);

  const yymmddsss = parseInt(`${yy}${mm}${dd}${sss}`, 10);
  let c = yymmddsss % 11;

  if (c === 10) {
    c = 0;
  }

  return `${yy}${mm}${dd}/${sss}${c}`;
};

export const generatePhoneNumber = () => {
  // custom function because faker.phone.number() doesn't work correctly
  // (it generates the numbers, but they are not validated sometimes) with Czech numbers'
  return `${PREFIX_PHONE} ${faker.number.int({
    min: 601,
    max: 799,
  })}${faker.string.numeric({ length: 6 })}`;
};

export const generateEmail = () => faker.internet.email();
